import { IconButton } from "@mui/material";
import { CopyIcon } from "components/icon";
import { useAlerts } from "contexts";
import StyledButton from "customStyled/StyledButton";
import React, { memo, useCallback } from "react";
import { clickCopyEvent } from "utils";
import { useTranslation } from "react-i18next";

// `msg`: the alert after copying (e.g. "Incident ID copied."), else "Copied"
const CopyUI = memo(({ text, copyLabel = null, msg = null }) => {
  const { t } = useTranslation();
  const { showAlerts } = useAlerts();
  const clickEvent = useCallback(async () => {
    const res = await clickCopyEvent(text);
    if (res) {
      showAlerts(msg || t("copied"));
    } else {
      showAlerts(t("somethingWentWrong"));
    }
  }, [t, text, msg, showAlerts]);
  if (!text) return null;

  return (
    <React.Fragment>
      {copyLabel ? (
        <StyledButton
          variant="text"
          startIcon={<CopyIcon fontSize="inherit" />}
          onClick={clickEvent}
        >
          {copyLabel}
        </StyledButton>
      ) : (
        <IconButton onClick={clickEvent} aria-label={t("copy")}>
          <CopyIcon fontSize="inherit" />
        </IconButton>
      )}
    </React.Fragment>
  );
});

export default CopyUI;
